import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

type RequiredFieldCheck<T extends FieldValues> = readonly [Path<T>, boolean];

/**
 * Sets a "required" error on each path whose `isMissing` is true. Returns true
 * if any error was set. Used at step boundaries where zodResolver does not
 * surface superRefine errors from nested conditional fields.
 */
export const setRequiredFieldErrors = <T extends FieldValues>(
  setError: UseFormSetError<T>,
  checks: RequiredFieldCheck<T>[],
  message = 'This field is required',
): boolean => {
  let hasErrors = false;
  for (const [path, isMissing] of checks) {
    if (isMissing) {
      setError(path, { type: 'custom', message });
      hasErrors = true;
    }
  }
  return hasErrors;
};
